import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHome} from "@fortawesome/free-solid-svg-icons";
import {Breadcrumb, Button} from '@themesberg/react-bootstrap';


import {ListOfDevices, PageVisitsTable,} from "../../components/Tables";


export default () => {
    return (
        <>
            <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-xl-0">
                    <Breadcrumb className="d-none d-md-inline-block"
                                listProps={{className: "breadcrumb-dark breadcrumb-transparent"}}>
                        <Breadcrumb.Item><FontAwesomeIcon icon={faHome}/></Breadcrumb.Item>
                        <Breadcrumb.Item>All Loans</Breadcrumb.Item>
                        <Breadcrumb.Item active>List of all loans</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4> All All loans</h4>
                </div>
            </div>
            <Button variant="primary" href="dashboard" className="m-1">Add device

            </Button>
            <ListOfDevices/>
            <h4>Active Loans</h4>
            <PageVisitsTable/>
            <h4>Defaulted Loans</h4>
            <PageVisitsTable/>

        </>
    );
};